import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoSiloam from "../../assets/logo_siloam.png";
import bg from "../../assets/bg_sos.jpg";
import imgHeader from "../../assets/header_sos.png";
import PopupAdd from "../../components/popup_add";

const PageInfo = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative w-full md:w-[500px] mx-auto h-screen flex flex-col justify-between items-center ">
        <img
          src={bg}
          className="absolute z-10 w-full h-full mx-auto object-cover"
          alt=""
        />

        <img
          src={imgHeader}
          className="absolute z-50 top-0 w-full object-contain mx-auto object-cover"
          alt=""
        />

        <div className="overflow-x-hidden z-10 relative flex flex-grow w-full h-auto justify-center items-center  px-5">
          <div className="flex flex-col justify-center items-center pb-20 w-full space-y-6">
            <div className=" text-white text-center font-bold text-2xl uppercase">
              <div className="mb-4">EVENT INFO</div>
            </div>

            <button
              onClick={() => navigate("/symposium")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              SYMPOSIUM
            </button>

            <button
              onClick={() => navigate("/workshop")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              WORKSHOP
            </button>

            <button
              onClick={() => navigate("/poster-competition")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              POSTER COMPETITION
            </button>

            <button
              onClick={() => navigate("/hotel")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              HOTEL
            </button>

            <button
              onClick={() => navigate("/documentation")}
              className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-white  font-bold"
            >
              DOKUMENTASI
            </button>

            <button
              onClick={() => navigate("/")}
              className="min-w-[240px] px-5 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
            >
              BACK
            </button>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default PageInfo;
